import App from './app';
import './styles.scss';
export default App;


// WEBPACK FOOTER //
// ./medscape_modules/email-modal/form/index.js